import { render, staticRenderFns } from "./MemberRedeemResultDialog.vue?vue&type=template&id=246b7b0e&scoped=true&"
import script from "./MemberRedeemResultDialog.vue?vue&type=script&lang=js&"
export * from "./MemberRedeemResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./MemberRedeemResultDialog.vue?vue&type=style&index=0&id=246b7b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b7b0e",
  null
  
)

export default component.exports